import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { SharedUiSkeletonFormModule } from '@frontend/common/skeletons';
import { PatientFormModule } from '../patient-form/patient-form.module';
import { UpdatePatientRoutedComponent } from './update-patient-routed.component';
import { UpdatePatientComponent } from './update-patient.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatDialogModule,
    SharedUiSkeletonFormModule,
    PatientFormModule,
  ],
  declarations: [UpdatePatientRoutedComponent, UpdatePatientComponent],
  exports: [UpdatePatientRoutedComponent, UpdatePatientComponent],
})
export class UpdatePatientModule {}
